<app-card
  title="Your FC2 Female Condom Confirmation!"
  data-qa-id="Order Complete Instructions"
  headerClasses="p-6 is-size-3 is-size-4-mobile has-text-weight-bold card-header-title has-text-white"
>
  <p class="mb-4">
    <strong>Zeal Specialty Pharmacy will text you when your FC2 order is ready to ship.</strong>
  </p>
  <p class="mb-4">
    Thank you for choosing to try the FC2 Female Condom, the only FDA-approved, female-controlled birth control option
    that helps protect against both unintended pregnancy and STIs. FC2 is covered by insurance at no cost to you. FC2
    condoms are not subject to copays or deductibles, so your order should be $0 out-of-pocket.
  </p>
  <p class="mb-4">
    Zeal Specialty Pharmacy will attempt to look up your insurance information. When your condoms are about to ship, you
    will receive a text message from Zeal with a confirmation. If Zeal is unable to locate your insurance, they will
    reach out to you directly to request your insurance information.
  </p>
  <p class="mb-4">
    We're excited for you to try FC2. Women who use it often rave about the control, comfort, and added peace of mind it
    provides.
  </p>
  <p>
    Thank you,
    <br />
    The Starfish.com Team
  </p>
</app-card>
